import React from 'react';
import cn from 'classnames';
import DateTime from '@dealroadshow/uikit-date-time';
import IconArrowLeft from '@creditflowresearch/uilib/Icon/IconArrowLeft';
import IconArrowRight from '@creditflowresearch/uilib/Icon/IconArrowRight';
import IconTriangleArrowBottom from '@creditflowresearch/uilib/Icon/IconTriangleArrowBottom';
import { CalendarView } from '../constants';
import styles from './calendarHeader.module.scss';
import IconButton from '@creditflowresearch/uilib/IconButton';

export interface ICalendarHeaderProps {
  date: Date,
  decreaseMonth: () => void,
  increaseMonth: () => void,
  decreaseYear: () => void,
  increaseYear: () => void,
  prevMonthButtonDisabled: boolean,
  nextMonthButtonDisabled: boolean,
  prevYearButtonDisabled: boolean,
  nextYearButtonDisabled: boolean,
  currentView: CalendarView,
  setView: (view: CalendarView) => void,
}

const CalendarHeader: React.FC<ICalendarHeaderProps> = ({
  date,
  decreaseMonth,
  increaseMonth,
  decreaseYear,
  increaseYear,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
  currentView,
  setView,
}) => {
  const month = new DateTime(date).format('MMM');
  const year = date.getFullYear();

  const preventFocusSteal = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  const toggleMonthsView = () => {
    setView(currentView === CalendarView.Months ? CalendarView.Days : CalendarView.Months);
  };

  const toggleYearsView = () => {
    setView(currentView === CalendarView.Years ? CalendarView.Days : CalendarView.Years);
  };

  return (
    <div className={ styles.header } data-test="datePickerCalendarHeader">
      <div className={ styles.section }>
        { currentView === CalendarView.Days && (
          <IconButton
            icon={ <IconArrowLeft className={ styles.navIcon } /> }
            className={ cn(styles.navButton, styles.prevButton) }
            onMouseDown={ preventFocusSteal }
            onClick={ decreaseMonth }
            disabled={ prevMonthButtonDisabled }
            ariaLabel="Previous month"
            dataTest="datePickerHeaderPrevMonth"
          />
        ) }
        <button
          type="button"
          className={ cn(styles.titleButton, { [styles.titleButtonActive]: currentView === CalendarView.Months }) }
          onMouseDown={ preventFocusSteal }
          onClick={ toggleMonthsView }
          data-test="datePickerHeaderMonth"
        >
          { month }
          <IconTriangleArrowBottom className={ styles.titleChevron } />
        </button>
        { currentView === CalendarView.Days && (
          <IconButton
            icon={ <IconArrowRight className={ styles.navIcon } /> }
            className={ cn(styles.navButton, styles.nextButton) }
            onMouseDown={ preventFocusSteal }
            onClick={ increaseMonth }
            disabled={ nextMonthButtonDisabled }
            ariaLabel="Next month"
            dataTest="datePickerHeaderNextMonth"
          />
        ) }
      </div>
      <div className={ styles.section }>
        { currentView === CalendarView.Days && (
          <IconButton
            icon={ <IconArrowLeft className={ styles.navIcon } /> }
            className={ cn(styles.navButton, styles.prevButton) }
            onMouseDown={ preventFocusSteal }
            onClick={ decreaseYear }
            disabled={ prevYearButtonDisabled }
            ariaLabel="Previous year"
            dataTest="datePickerHeaderPrevYear"
          />
        ) }
        <button
          type="button"
          className={ cn(styles.titleButton, { [styles.titleButtonActive]: currentView === CalendarView.Years }) }
          onMouseDown={ preventFocusSteal }
          onClick={ toggleYearsView }
          data-test="datePickerHeaderYear"
        >
          { year }
          <IconTriangleArrowBottom className={ styles.titleChevron } />
        </button>
        { currentView === CalendarView.Days && (
          <IconButton
            icon={ <IconArrowRight className={ styles.navIcon } /> }
            className={ cn(styles.navButton, styles.nextButton) }
            onMouseDown={ preventFocusSteal }
            onClick={ increaseYear }
            disabled={ nextYearButtonDisabled }
            ariaLabel="Next year"
            dataTest="datePickerHeaderNextYear"
          />
        ) }
      </div>
    </div>
  );
};

export default CalendarHeader;
